import React from 'react';
import { Row, Col, Card } from 'antd';
import { EditOutlined, EllipsisOutlined, GlobalOutlined, SettingOutlined } from '@ant-design/icons';

import LayoutDetail from '../Layout/'
import { connect } from 'react-redux'
//import Maker from '../../components/';

const Dashboard = ({ usuario, asyncIncrement, increment }) => (

	<LayoutDetail  breadCrumbs={['Dashboard']}>
		<Row>
			<Col xs={24} sm={24} md={12} lg={10} xl={10}>
				<Row>
					<Col xs={24} sm={24} md={12} lg={12} xl={12}>
						<Card title="Entregas a fazer" extra={<a href="#">Detalhes</a>} actions={[
							<SettingOutlined key="setting" />,
							<GlobalOutlined key="edit" />,
							<EllipsisOutlined key="ellipsis" />,
						]}
						>
							<h1 style={{ color: 'red', fontSize: 50 }}>0</h1>
						</Card>

					</Col>
					<Col xs={24} sm={24} md={12} lg={12} xl={12}>
						<Card title="Entregas Feitas" extra={<a href="#">Detalhes</a>} actions={[
							<SettingOutlined key="setting" />,
							<GlobalOutlined key="edit" />,
							<EllipsisOutlined key="ellipsis" />,
						]}
						>
							<h1 style={{ color: 'green', fontSize: 50 }}>0</h1>
						</Card>
					</Col>
				</Row>
				<Row>
					<Col xs={24} sm={24} md={12} lg={12} xl={12}>
						<Card title="Receitas de hoje" extra={<a href="#">Detalhes</a>} actions={[
							<SettingOutlined key="setting" />,
							
							<EllipsisOutlined key="ellipsis" />,
						]}
						>
							<h1 style={{ color: '#333', fontSize: 50 }}>0</h1>
							<p>eVpresc</p>
						</Card>

					</Col>
					<Col xs={24} sm={24} md={12} lg={12} xl={12}>
						<Card title="Total de Receitas" extra={<a href="#">Detalhes</a>} actions={[
							<SettingOutlined key="setting" />,
						
							<EllipsisOutlined key="ellipsis" />,
						]}
						>
							<h1 style={{ color: '#333', fontSize: 50 }}>0</h1>
							<p>eVpresc</p>
						</Card>
					</Col>
				</Row>
				<Row></Row>
			</Col>
			<Col xs={24} sm={24} md={12} lg={14} xl={14}>
				{/* <GoogleMap
				defaultZoom={10}
				defaultCenter={LOS_ANGELES_CENTER}
				yesIWantToUseGoogleMapApiInternals
				onGoogleApiLoaded={({ map, maps }) => apiIsLoaded(map, maps, places)}
			>
            {places.map((place) => (
              <Marker
                key={place.id}
                text={place.name}
                lat={place.geometry.location.lat}
                lng={place.geometry.location.lng}
              />
            ))}
          </GoogleMap> */}
			</Col>
		</Row>
	</LayoutDetail>


)
const mapState = (state) => ({
	usuario: state.usuario,
})
const mapDispatch = (dispatch) => ({
	increment: dispatch.usuario.increment,
	asyncIncrement: dispatch.usuario.asyncIncrement,
})

export default connect(mapState, mapDispatch)(Dashboard)
